import { render, staticRenderFns } from "./Proveedores.vue?vue&type=template&id=8491f016&scoped=true"
import script from "./Proveedores.vue?vue&type=script&lang=js"
export * from "./Proveedores.vue?vue&type=script&lang=js"
import style0 from "./Proveedores.vue?vue&type=style&index=0&id=8491f016&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8491f016",
  null
  
)

export default component.exports